import { AcknowledgementName } from "@wingspanhq/wingspan-api-sdk";
import { WSMutationConfig } from "@ws-react-query";
import { queriesAcknowledgements, queriesPayers } from "@query";
import { payersApi, personsApi } from "@api";
import { useSession } from "@hooks/useSession";
import { useWSMutation } from "../../../query/helpers";
import { useUserId } from "../../../query/hooks/helpers";
import { QUERY_USERS_ACTIVITIES } from "../../../query/users/keys";
import { usersService } from "../../../services/users";
import {
  concurrentActions,
  WSServiceError
} from "../../../utils/serviceHelper";
import { acknowledgementVersions } from "../../constants/acknowledgements";
import { selectorPersonDisplayName } from "../../selectors/selectorPersonDisplayName";
import { buildTaxInformationConsent } from "../../utils/buildTaxInformationConsent";

export const useMutationSubmit = (config?: WSMutationConfig<void>) => {
  const userId = useUserId();
  const { personId } = useSession();
  const queryPayers = queriesPayers.listPayers.useQueryAll();

  const [acceptAcknowledgement] =
    queriesAcknowledgements.acceptAcknowledgement.useMutation();

  return useWSMutation<any, WSServiceError>(
    async () => {
      const payers = queryPayers.flatData ?? [];

      // TODO(v3): per-payer tax-information share. INTERIM consent: the signature is derived
      // from the payee's on-file legal name (no dedicated e-signature capture yet) —
      // DOUBLE-CHECK pending Legal sign-off; see buildTaxInformationConsent.
      // `payer.id` is the v3 Payer id (from listPayers), so the v3 verb resolves.
      const person = await personsApi.getPerson({ personId });
      const consent = buildTaxInformationConsent({
        signature: selectorPersonDisplayName(person)
      });

      await concurrentActions(
        payers.map(
          payer => () =>
            payersApi.shareTaxInformation({
              payerId: payer.id ?? "",
              payerShareTaxInformationRequest: { consent }
            })
        )
      );

      await usersService.activity.update(userId, {
        events: {
          w9FormAcknowledged: new Date()
        }
      });

      await acceptAcknowledgement({
        acknowledgementName: AcknowledgementName.W9_CERTIFICATION,
        acceptAcknowledgementRequest: {
          version: acknowledgementVersions[AcknowledgementName.W9_CERTIFICATION]
        }
      });
    },
    {
      dependencies: [QUERY_USERS_ACTIVITIES],
      ...config
    }
  );
};
